import type { ResultOf, VariablesOf } from '@graphql-typed-document-node/core';

import { input } from '../../common/requests/base.input.ts';
import { mutation } from '../../common/requests/base.mutation.ts';
import { ResultType } from '../../main/types/result.types.ts';
import { getReadingCrittersClientUtil } from '../../main/utils/clients/readingcritters.client.util.ts';

const CREATE_CHILD_PROFILE_MUTATION = mutation({
  createChildProfile: [
    { input: input('input', 'CreateChildProfileInput!') },
    {
      success: true,
    },
  ],
});

type CreateChildProfileInputType = VariablesOf<typeof CREATE_CHILD_PROFILE_MUTATION>['input'];
type CreateChildProfileResponseType = ResultOf<typeof CREATE_CHILD_PROFILE_MUTATION>['createChildProfile'];

export const createChildProfileMutationRequest = async (
  props: CreateChildProfileInputType
): Promise<ResultType<CreateChildProfileResponseType>> => {
  const client = getReadingCrittersClientUtil();

  try {
    const response = await client.mutation(CREATE_CHILD_PROFILE_MUTATION, { input: props }, { useAuth: true });

    return {
      success: Boolean(response?.createChildProfile?.success),
      data: response?.createChildProfile ?? { success: false },
    };
  } catch (error) {
    return {
      success: false,
      message: (error as Error).message,
    };
  }
};
